type SacHorarioAtendimentoProps = {
  prefixo: string
  horarioAtendimentoInicio?: string
  horarioAtendimentoFim?: string
  exibirHorarioAtendimento?: boolean
}

export default function SacHorarioAtendimento({
  prefixo,
  horarioAtendimentoInicio,
  horarioAtendimentoFim,
  exibirHorarioAtendimento,
}: SacHorarioAtendimentoProps) {
  return (
    <>
      {exibirHorarioAtendimento && (
        <span>
          {prefixo}, das {horarioAtendimentoInicio}h às {horarioAtendimentoFim}h
        </span>
      )}
    </>
  )
}
